import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { VcCoreLibModule } from '@libs/vc-core-lib';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    VcCoreLibModule,
  ]
})
export class VcOrgLibModule { }
